module.exports = __webpack_public_path__ + "img/box-aufklappen-weiss.f8c683ee.svg";